import React from "react";
import { FiTrendingUp, FiTrendingDown } from "react-icons/fi";
const StatCard = ({ item }) => {
  return (
    <div className={`w-full rounded-2xl p-5 ${item.bg}`}>
      
      {/* TOP ROW : Title + Icon */}
      <div className="flex items-start justify-between">
        <p className="text-base font-medium text-[#1C1C1C]">
          {item.title}
        </p>

        <div
          className={`w-9 h-9 rounded-lg flex items-center justify-center ${item.iconBg}`}
        >
          <span className={`${item.iconText} text-sm`}>
            {item.icon}
          </span>
        </div>
      </div>

      {/* BOTTOM ROW : Value + Trend */}
      <div className="flex items-center justify-between mt-3">
        <h2 className="text-2xl font-semibold text-[#1C1C1C]">
          {item.value}
        </h2>

        <div className="flex items-center gap-1">
          <span className={`text-sm font-medium ${item.textColor}`}>
            {item.change}
          </span>

          {item.trend === "up" ? (
            <FiTrendingUp strokeWidth={2} className="w-4 h-4 text-green-500" />
          ) : (
            <FiTrendingDown strokeWidth={2} className="w-4 h-4 text-red-500" />
          )}
        </div>
      </div>
    </div>
  );
};

export default StatCard;
